import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { CHECKOUT_URL } from '../lib/config';
export function Precio() {
  const incluye = ['6 tomos digitales completos', '4 bonos prácticos incluidos', 'Checklists de control listos para usar', 'Guías paso a paso en lenguaje simple', 'Acceso inmediato tras la compra', 'Lectura desde celular, computadora o tablet'];
  return <section id="precio" className="bg-gradient-to-br from-mc-dark to-mc-gray py-[72px] px-5" data-id="element-133">
      <div className="max-w-[1100px] mx-auto" data-id="element-134">
        <FadeIn data-id="element-135">
          <SectionHeading centered data-id="element-136">
            Protegé tu bolsillo por{' '}
            <span className="text-mc-yellow" data-id="element-137">
              menos de lo que cuesta una revisión
            </span>
          </SectionHeading>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-138">
          <div className="max-w-[520px] mx-auto mt-10 bg-mc-dark2 border-[3px] border-mc-yellow rounded-2xl py-10 px-8 text-center shadow-glow-lg relative" data-id="element-139">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-mc-yellow text-mc-dark font-display text-[0.78rem] font-black tracking-wide uppercase py-1.5 px-5 rounded-full whitespace-nowrap" data-id="element-140">
              🔥 Oferta especial — Acceso inmediato
            </div>

            <div className="font-display text-[1.4rem] font-black uppercase mb-2" data-id="element-141">
              Pack Taller Blindado
            </div>

            <div className="text-[0.95rem] text-mc-gray3 line-through mb-1" data-id="element-142">
              Valor real: $49.999 ARS
            </div>

            <div className="font-display text-5xl font-black text-mc-yellow leading-none mb-1.5" data-id="element-143">
              <span className="text-[1.4rem] align-super" data-id="element-144">$</span>19.999{' '}
              <small className="text-[1.2rem] text-mc-text font-body font-normal" data-id="element-145">
                ARS
              </small>
            </div>

            <p className="text-[0.88rem] text-mc-text mb-6 leading-relaxed" data-id="element-146">
              Una sola reparación mal cobrada puede costarte mucho más que este
              pack.
            </p>

            <ul className="flex flex-col gap-2.5 mb-8 text-left list-none" data-id="element-147">
              {incluye.map((item, i) => <li key={i} className="flex items-center gap-2.5 text-[0.93rem] text-gray-200" data-id="element-148">
                  <span className="text-mc-yellow font-black shrink-0" data-id="element-149">✔</span>
                  {item}
                </li>)}
            </ul>

            <Button size="large" href={CHECKOUT_URL} className="w-full" data-id="element-150">
              🛡️ Comprar Pack Taller Blindado
            </Button>

            <div className="text-[0.78rem] text-mc-gray3 mt-4 flex items-center justify-center gap-1.5" data-id="element-151">
              🔒 Pago seguro — Acceso digital inmediato
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}